/**
 * True when `id` looks like a real Driver primary key (UUID), not a placeholder like "0".
 */
export function isValidDriverRecordId(id: string | undefined | null): boolean {
  if (!id || id === '0') return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    id
  );
}
